import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaTh, FaList } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Card, Button, InputGroup, FormControl, Spinner, Alert } from "react-bootstrap";

const Membergrp = () => {
  const { id } = useParams();
  const [members, setMembers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [view, setView] = useState("grid");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("jwttoken");
  const BASE_URL = "https://kaasbackend.vetrinahealthcare.com";
  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/socialapp/groups/${id}/`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setMembers(response.data.members);
      } catch (error) {
        setError("Failed to fetch members");
      } finally {
        setLoading(false);
      }
    };

    fetchMembers();
  }, [id, token]);

  const filteredMembers = members.filter(
    (member) =>
      member.first_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      member.last_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Container className="p-3 bg-white shadow-sm rounded">
      <h5>Member</h5>
      <InputGroup className="mb-3">
        <FormControl
          placeholder="Search Members..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <Button
          className={`btn me-2 ${view === "grid" ? "text-white" : "text-dark"}`}
          style={{
            background: view === "grid" ? "#B8529E" : "transparent",
            border: "1px solid #B8529E",
          }}
          onClick={() => setView("grid")}
        >
          <FaTh />
        </Button>

        <Button
          className={`btn ${view === "list" ? "text-white" : "text-dark"}`}
          style={{
            background: view === "list" ? "#B8529E" : "transparent",
            border: "1px solid #B8529E",
          }}
          onClick={() => setView("list")}
        >
          <FaList />
        </Button>
      </InputGroup>

      {/* Section Title */}
      <h6 className="fw-bold mb-3 text-center">Organizers</h6>

      {/* Member List/Grid */}
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      ) : error ? (
        <Alert variant="danger" className="text-center">
          {error}
        </Alert>
      ) : filteredMembers.length > 0 ? (
        <Row className={view === "grid" ? "justify-content-start" : "flex-column align-items-center"}>
          {filteredMembers.map((member, index) => {
            // Determine profile picture URL
            const profilePic = member.profile_pic && member.profile_pic.trim() !== "" 
            ? member.profile_pic 
            : null;

            return (
              <Col key={index} xs={10} sm={6} md={2} className="mb-3">
                <Card className="text-center shadow-sm border-0 p-3" style={{ backgroundColor: "#E9F7FA" }}>
                  <div className="position-relative mx-auto" style={{ width: "60px", height: "60px" }}>
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center shadow-sm w-100 h-100 overflow-hidden">
                    {profilePic ? (
                <img 
                  src={profilePic} 
                  alt="Profile" 
                  className="rounded-circle w-100 h-100" 
                  style={{ objectFit: 'cover' }} 
                  referrerPolicy="no-referrer"
                />
                      ) : (
                        <span className="fw-bold text-secondary">
                          {member.first_name.charAt(0)}
                          {member.last_name ? member.last_name.charAt(0) : ""}
                        </span>
                      )}
                    </div>
                    <span
                      className="position-absolute top-0 end-0 bg-success rounded-circle"
                      style={{ width: "10px", height: "10px" }}
                    ></span>
                  </div>
                  <Card.Body>
                    <Card.Title className="fw-bold">{member.first_name} {member.last_name}</Card.Title>
                    <Card.Text className="text-muted small">Joined 5 weeks ago • Active now</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            );
          })}
        </Row>
      ) : (
        <p className="text-center text-muted">No members found.</p>
      )}

      {/* Footer Section */}
      <p className="text-muted text-center mt-3">
        Viewing {filteredMembers.length} member{filteredMembers.length !== 1 ? "s" : ""}
      </p>
    </Container>
  );
};

export default Membergrp;
